export function checkIfAlreadyFavourites(ids, shopUserId, tmpCommunityType) {
    if (shopUserId !== "") {
        $.ajax({
            type: "POST",
            url: "/module/community/ajax.php?action=check_if_already_favourites",
            datatype: "json",
            data: {
                "ajax_call_ids": ids,
                "ajax_call_shop_user_id": shopUserId,
                "ajax_call_community_type": tmpCommunityType,
                "ajax_call_community_type_global": communityType
            },
            success: function (output) {
                var data = $.parseJSON(output);
                $.each(data, function(key,value) {
                    var valueId = value.id;
                    if (value.id === undefined) {
                        valueId = value;
                    }
                    $(".timeline_entry#" + valueId).find(".add_to_favourites").addClass("active");
                });
            }
        });
    }
}
